import React, { useRef, useState } from "react";
import StaffProfileCard from "../../../Staff/partials/StaffProfileCard";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction"; // needed for dayClick
import { useMutation } from "@apollo/react-hooks";
import { ADD_NOTE } from "../../../../queries/timetable.query";
import LoadingSpinner from "../../../../partials/loading";
import AlertMessage from "../../../../partials/alertMessage";

import "../../../../util/calendar.css";
import NewTimetableNote from "./NewTimetableNote";
import { cleanDate } from "../../../../util/app";
import { sendNotification } from "../../../../sockette";
import { ACTION_TYPE, EVENT_TARGET } from "../../../../event/model";

const TimetableDetail = ({ item, onNewNote }) => {
    const [event, setEvent] = useState(null);
    const calRef = useRef();
    const [AddFunc, { loading, data, error }] = useMutation(ADD_NOTE, {
        notifyOnNetworkStatusChange: true,
        onCompleted: (d) => {
            const { message } = d.AddMoreNoteToTimetable;
            sendNotification(message, ACTION_TYPE.UPDATE, EVENT_TARGET.TIMETABLE);
        },
    });

    if (item)
        return (
            <>
                <div className="card">
                    <div className="card-body m-b-10 m-t-10">
                        <div className="row justify-content center">
                            <div className="col">
                                <strong>{cleanDate(item.start)}</strong>
                                <br />
                                <small>Start Date & Time</small>
                            </div>
                            <div className="col">
                                <strong>{cleanDate(item.end)}</strong>
                                <br />
                                <small>End Date & Time</small>
                            </div>
                            <div className="col-4">
                                <StaffProfileCard item={item.author} />
                            </div>
                        </div>
                    </div>
                </div>
                {event && (
                    <div className="fade-in">
                        <NewTimetableNote
                            onCancel={() => setEvent(null)}
                            onSubmit={async ({ note }) => {
                                await AddFunc({
                                    variables: {
                                        id: item.id,
                                        note: { note, datetime: event.date },
                                    },
                                });
                                setEvent(null);
                            }}
                        />
                    </div>
                )}
                <div className="card">
                    <div className="card-body m-b-20">
                        <div className="row ">
                            <div className="col-md-12">
                                <LoadingSpinner loading={loading} />
                                <AlertMessage message={error && error.message} failed={true} />
                                <AlertMessage message={data && data.AddMoreNoteToTimetable.message} />
                            </div>
                            <div className="col-md-12">
                                <FullCalendar
                                    defaultView="dayGridMonth"
                                    header={{
                                        left: "prev,next today",
                                        center: "title",
                                        right: "dayGridMonth,timeGridWeek,timeGridDay,listWeek",
                                    }}
                                    plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                                    ref={calRef}
                                    weekends={true}
                                    events={item.plans}
                                    dateClick={(event) => {
                                        setEvent(event);
                                        document.body.scrollTop = 0;
                                        document.documentElement.scrollTop = 0;
                                    }}
                                    defaultDate={item.start}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    else return null;
};
export default TimetableDetail;
